<template>
    <div
        v-editable="blok"
        class="standard-content"
        :class="{ 'standard-content--full': width === 'full' }"
        data-test="NewL4StandardContent"
        :style="{ textAlign: align }"
    >
        <div class="standard-content__container md:container">
            <template v-for="contentItem in content" :key="contentItem._uid">
                <RichText :richtext="{ content: contentItem }" />
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IL4StandardContent } from '~/types/components/L4StandardContent';
import OTCookieButtonComponent from '~/components/OTComomponents/OTCookieButton.vue';
import OTCookieTablesComponent from '~/components/OTComomponents/OTCookieTables.vue';

const { blok } = defineProps<{ blok: IL4StandardContent }>();
const { width, content, align } = blok;

const customComponentName = (componentName: string) => {
    switch (componentName) {
        case 'OTCookieButton':
            return OTCookieButtonComponent;
        case 'OTCookieTables':
            return OTCookieTablesComponent;
        default:
            return componentName;
    }
};
</script>

<style lang="postcss" scoped>
.standard-content {
    @apply my-5;
    &--full {
        @apply bg-white px-4 my-0;
    }
    &__container {
        @apply bg-white text-bodypurple py-4 px-5;
        .standard-content--full & {
            @apply py-8 px-0;
        }
        & :deep(.title) {
            @apply block mb-4 text-[38px]/[42px] font-normal text-primary;
        }
        & :deep(p) {
            @apply text-base leading-6 mb-4 mb-3 mt-0;
        }
        & :deep(.titled-area) {
            @apply block pb-0.5 border-b-[#c8acd2] border-b border-solid text-xl font-semibold;
        }
        & :deep(.sub-title) {
            @apply text-xl font-semibold;
        }
        & :deep(h1) {
            @apply text-3xl;
        }
        & :deep(h2) {
            @apply text-[32px] mt-0 leading-8;
        }
        & :deep(h3),
        & :deep(h4) {
            @apply text-base leading-6 mb-4 mt-0;
        }
    }
    &__text {
        @apply text-center flex flex-col justify-evenly text-primary text-sm p-1;
    }
}
</style>
